import { NgModule } from '@angular/core';
import { NumberOnlyDirective } from './onlyNumbers.directive';

@NgModule({
  declarations: [NumberOnlyDirective],
  exports: [NumberOnlyDirective],
})
export class NumberOnlyModule {}
